import React from 'react';
import { Juridiction, City, Typologies } from './lawyerSnippet.types';
import {
  fetchLawyerCustomers,
  fetchLawyerDecisions,
} from '../../../../../lawyer/lawyer.api';
import {
  cleanObject,
  getTypologiesFormatted,
} from '../../../../../entity/charts/typologies/chartTypologies.utils';

type State = {
  juridictions: Array<Juridiction>;
  villes: Array<City>;
  typologies: Typologies | null;
};

type Props = {
  lawyerId: string;
  children: (props: State) => React.ReactNode;
};

export type LawyerSnippetFetcherProps = State;

export class LawyerSnippetFetcher extends React.Component<Props, State> {
  state: State = {
    juridictions: [],
    villes: [],
    typologies: null,
  };

  isMounted = false;

  componentDidMount() {
    this.isMounted = true;
    this.loadData(this.props.lawyerId);
  }

  async componentDidUpdate(prevProps: Props) {
    if (this.props.lawyerId !== prevProps.lawyerId) {
      await this.loadData(this.props.lawyerId);
    }
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  async loadData(lawyerId: string) {
    try {
      const [{ juridictions, villes }, { typologies }] = await Promise.all([
        fetchLawyerDecisions(lawyerId),
        fetchLawyerCustomers(lawyerId),
      ]);

      const nextState: State = { juridictions, villes, typologies: null };
      if (this.isMounted) {
        let datas = [];
        let labels = [];
        const formattedTypologies = getTypologiesFormatted(typologies);
        if (formattedTypologies !== null) {
          const cleanTypologies = cleanObject(formattedTypologies);
          datas = cleanTypologies.map(d => Math.round(d[1]));
          labels = cleanTypologies.map(c => c[0]);
          nextState.typologies = { datas, labels };
        }

        this.setState(nextState);
      }
    } catch (error) {
      throw error;
    }
  }

  render() {
    return this.props.children({ ...this.state });
  }
}
